<template>
    <div class="">
        <section class="checkout_wizard pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div
                            class="wizard d-flex justify-content-center align-items-center"
                        >
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Shopping Cart</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Checkout</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">3</div>
                                <h5 class="mb-0">Review & Pay</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item"><a href="#">Cart</a></li>
                        <li class="breadcrumb-item">
                            <a href="#">Checkout</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Review & Pay
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="shipping_payment_detail review_pay pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 mb_22">
                        <h1 class="heading1">Review & Pay</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-6 pr_78">
                        <div class="white_box py_36 px_50 h-100">
                            <h4 class="font_size_30 d-flex mb_24">
                                Billing Address
                                <a href="#" class="ml-auto"
                                    ><img
                                        src="/maincss/images/edit.svg"
                                        alt=" "
                                /></a>
                            </h4>

                            <div class="presnol_info mt_22">
                                <h4 class="font_size_18">Micheal Joe</h4>
                                <p class="mb-0 text_light_grey">
                                    michal.joe@gmail.com
                                </p>
                                <p class="mb-0 text_light_grey">
                                    United States of America
                                </p>
                                <p class="mb-0 text_light_grey">California</p>
                                <p class="mb-0 text_light_grey">90202</p>

                                <p class="mb-0 text_light_grey mt_14">
                                    Near BT College, 148 Spring St
                                </p>
                                <p class="mb-0 text_light_grey">
                                    (202) 235-6088
                                </p>
                            </div>

                            <h4 class="font_size_30 d-flex mb_24 mt_60">
                                Payment Method
                                <a href="#" class="ml-auto"
                                    ><img
                                        src="/maincss/images/edit.svg"
                                        alt=" "
                                /></a>
                            </h4>

                            <div class="presnol_info mt_22">
                                <p class="mb-0 text_light_grey">
                                    <img
                                        src="/maincss/images/visa_logo.png"
                                        alt=" "
                                        class="mr_14"
                                    />ending with 5678
                                </p>
                            </div>

                            <h4 class="font_size_30 d-flex mb_24 mt_60">
                                Pay With a Gift Card
                                <a href="#" class="ml-auto"
                                    ><img
                                        src="/maincss/images/edit.svg"
                                        alt=" "
                                /></a>
                            </h4>
                            <div class="gifts_cards">
                                <div class="row align-items-end">
                                    <div class="col-md-12 col-lg-9 col-xlg-9">
                                        <p class="mb-0 font_size_14">
                                            Add gift card codes one at a time
                                        </p>
                                        <div class="d-md-flex gift_card">
                                            <div
                                                class="form-group ml-0 gift_card_number"
                                            >
                                                <input
                                                    type="text"
                                                    id="Email"
                                                    required="required"
                                                    placeholder="Gift card number"
                                                    value=""
                                                    class="form-control"
                                                />
                                                <span class="highlight"></span>
                                            </div>

                                            <div
                                                class="form-group enter_pin ml-auto"
                                            >
                                                <input
                                                    type="text"
                                                    id="Email"
                                                    required="required"
                                                    placeholder="Enter PIN  "
                                                    value=""
                                                    class="form-control"
                                                />
                                                <span class="highlight"></span>

                                                <div
                                                    data-toggle="tooltip"
                                                    data-placement="bottom"
                                                    title=""
                                                    class="alert-icon pb-2"
                                                    data-original-title="Tooltip on bottom"
                                                >
                                                    <img
                                                        src="/maincss/images/information.svg"
                                                        alt=" "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 col-lg-3 col-xlg-3 text-xlg-right"
                                    >
                                        <a
                                            href="#"
                                            class="btn btn_outline_primary border_primary_blue text_primary_blue ml-auto py_10 px_34 mt-4 mt-xlg-0"
                                            >ADD</a
                                        >
                                    </div>
                                </div>
                            </div>

                            <div class="coupon mt_34">
                                <div class="row align-items-end">
                                    <div class="col-md-12 col-lg-9 col-xlg-9">
                                        <p class="mb-0 font_size_14">
                                            Apply a Coupon Code
                                        </p>
                                        <div class="d-flex coupon">
                                            <div class="form-group ml-0 w-100">
                                                <input
                                                    type="text"
                                                    id="Email"
                                                    required="required"
                                                    placeholder="Enter code"
                                                    value=""
                                                    class="form-control"
                                                />
                                                <span class="highlight"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 col-lg-3 col-xlg-3 text-xlg-right"
                                    >
                                        <a
                                            href="#"
                                            class="btn btn_outline_primary border_primary_blue text_primary_blue ml-auto py_10 px_34 mt-4 mt-xlg-0"
                                            >Apply</a
                                        >
                                    </div>
                                </div>
                            </div>

                            <div class="coupon mt_34">
                                <div class="row align-items-end">
                                    <div class="col-md-12 col-lg-9 col-xlg-9">
                                        <p class="mb-0 font_size_14">
                                            Any Special Comments
                                        </p>
                                        <div class="d-flex coupon">
                                            <div class="form-group ml-0 w-100">
                                                <textarea
                                                    class="form-control"
                                                    placeholder="Enter here"
                                                >
                                                </textarea>
                                                <span class="highlight"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h4 class="font_size_30 d-flex mb_24 mt_60">
                                Shipping Carrier
                                <a href="#" class="ml-auto"
                                    ><img
                                        src="/maincss/images/edit.svg"
                                        alt=" "
                                /></a>
                            </h4>

                            <div class="presnol_info mt_22">
                                <p class="mb-0 text_light_grey">
                                    <img
                                        src="/maincss/images/review_pay.png"
                                        alt=" "
                                    />
                                </p>
                            </div>

                            <h4 class="font_size_30 d-flex mb_24 mt_60">
                                Shipping methods
                                <a href="#" class="ml-auto"
                                    ><img
                                        src="/maincss/images/edit.svg"
                                        alt=" "
                                /></a>
                            </h4>

                            <div class="presnol_info mt_22">
                                <p class="mb-0 text_light_grey">Ground</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <div class="cart_summary h-100 white_box py_50 px_68">
                            <h4 class="font_size_30 d-flex mb_28">
                                Cart Summary
                                <a href="#" class="ml-auto"
                                    ><img
                                        src="/maincss/images/edit.svg"
                                        alt=" "
                                /></a>
                            </h4>

                            <div class="cart_items media">
                                <img
                                    src="/maincss/images/cart_tshirt_1.png"
                                    alt=""
                                    class="mr_34"
                                />
                                <div class="media-body">
                                    <h4 class="font_size_20 d-md-flex mb-0">
                                        12 X Port & Company Core Blend Tee
                                        <span class="font_size_22 ml-auto"
                                            >$180.00</span
                                        >
                                    </h4>
                                    <p
                                        class="font_size_16 mt_8 mb-0 text_light_grey"
                                    >
                                        T-Shirt
                                    </p>
                                    <p
                                        class="font_size_16 mb-0 text_light_grey"
                                    >
                                        XS: 10, S: 2 Edit
                                    </p>
                                </div>
                            </div>

                            <div class="cart_items media">
                                <img
                                    src="/maincss/images/cart_tshirt_2.png"
                                    alt=""
                                    class="mr_34"
                                />
                                <div class="media-body">
                                    <h4 class="font_size_20 d-md-flex mb-0">
                                        12 X Soft Crown Caps
                                        <span class="font_size_22 ml-auto"
                                            >$180.00</span
                                        >
                                    </h4>
                                    <p
                                        class="font_size_16 mt_8 mb-0 text_light_grey"
                                    >
                                        Cap
                                    </p>
                                    <p
                                        class="font_size_16 mb-0 text_light_grey"
                                    >
                                        XS: 2, S: 10
                                    </p>
                                </div>
                            </div>

                            <div class="cart_items media">
                                <img
                                    src="/maincss/images/cart_tshirt_3.png"
                                    alt=""
                                    class="mr_34"
                                />
                                <div class="media-body">
                                    <h4 class="font_size_20 d-md-flex mb-0">
                                        144 X C-Handle 11oz Mugs<span
                                            class="font_size_22 ml-auto"
                                            >$516.00</span
                                        >
                                    </h4>
                                    <p
                                        class="font_size_16 mt_8 mb-0 text_light_grey"
                                    >
                                        Mugs
                                    </p>
                                    <p
                                        class="font_size_16 mb-0 text_light_grey"
                                    >
                                        144
                                    </p>
                                </div>
                            </div>

                            <div class="cart_items media">
                                <div class="product_image">
                                    <img
                                        src="/maincss/images/cart_tshirt_4.png"
                                        alt=""
                                        class="mr_34"
                                    />
                                </div>
                                <div class="media-body">
                                    <h4 class="font_size_20 d-md-flex mb-0">
                                        2 X Champion Drawstring Bag
                                        <span class="font_size_22 ml-auto"
                                            >$50.00</span
                                        >
                                    </h4>
                                    <p
                                        class="font_size_16 mt_8 mb-0 text_light_grey"
                                    >
                                        Bag
                                    </p>
                                    <p
                                        class="font_size_16 mb-0 text_light_grey"
                                    >
                                        M: 2
                                    </p>
                                </div>
                            </div>

                            <div class="total_coast d-flex text-right">
                                <h5>Total:</h5>
                                <h3>$926</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- <section class="footer_buttons pt-0 pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 m-auto text-center">
                        <a
                            href="/"
                            class="btn btn_orange bg_primary_orange text_white"
                            >Proceed to pay</a
                        >

                        <p class="font_size_16 text_light_grey mb-0 mt_30">
                            By placing your order at
                            <a href="#" class="text_primary_blue btn_link"
                                >imprintcity.com</a
                            >
                            you’re agreeing to our
                        </p>
                        <p class="font_size_16 text_light_grey">
                            <a href="#" class="text_primary_blue btn_link"
                                >Privacy Policy</a
                            >
                            &
                            <a href="#" class="text_primary_blue btn_link"
                                >Terms & Conditions</a
                            >. We may occasionally email you product
                            information.
                        </p>
                    </div>
                </div>
            </div>
        </section> -->
    </div>
</template>

<script>
export default {
    name: "ReviewPay",
    components: {},
    mounted() {
        document.body.classList.add("bg_primary_light_white");
    }
};
</script>
